
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Published"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_company_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_contact_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkedin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebook"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_website"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_dropship"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_average_margin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promo_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_mdf_percent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_map_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_map_policy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_sales_model"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_teaser_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_long_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_dealer_requirements"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile_cover"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ext"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_search_img"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ext"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_desc_img"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ext"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":906}};
    doc.loc.source = {"body":"query GetCompanyProfile(\n  $id: ID!\n) {\n    company(id: $id) {\n      id\n      profile{\n        id\n        Published\n        profile_company_name\n        profile_city\n        profile_state\n        profile_contact_email\n        instagram\n        linkedin\n        facebook\n        profile_category\n        profile_phone\n        profile_website\n        profile_dropship\n        profile_average_margin\n        promo_text\n        profile_mdf_percent\n        profile_map_text\n        profile_map_policy\n        profile_sales_model\n        profile_teaser_description\n        profile_long_description\n        profile_dealer_requirements\n      profile_cover{\n        id\n        url \n        name\n        ext\n      }\n      profile_search_img{\n              id\n              url \n              name\n              ext\n      }\n      profile_desc_img{\n        id\n        url\n        name\n        ext\n      }\n      }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["GetCompanyProfile"] = oneQuery(doc, "GetCompanyProfile");
        
